import { mxCylinder, mxConstants } from "../utils/graph/mxModule";

function pmosStickShape() {}
pmosStickShape.prototype = new mxCylinder();
pmosStickShape.prototype.constructor = pmosStickShape;

// Port positions relative to the 120×70 vertex (the actual placed size).
// innerW=100, innerH=50 fixed → S at x=35/120, D at x=85/120, both at y=0.5
// G_top and G_bottom are the same electrical node (gate poly endpoints).
pmosStickShape.config = {
  width: 70,
  height: 70,
  ports: [
    { name: "G", label: "", x: 0.5, y: 0 }, // top of gate poly
    { name: "G", label: "", x: 0.5, y: 1 }, // bottom of gate poly (same node)
    { name: "S", label: "", x: 0, y: 0.5 }, // source diffusion ≈ 0.292
    { name: "D", label: "", x: 1, y: 0.5 }, // drain diffusion  ≈ 0.708
  ],
};

pmosStickShape.prototype.paintVertexShape = function (c, x, y, w, h) {
  const style = this.style || {};
  const isFlipped = style.flipH === 1 || style.flipH === "1" || style[mxConstants.STYLE_FLIPH] === 1;
  const circleColor = style.circleColor || '#000000';
  const labelColor = style.fontColor || style.circleColor || '#000000';

  c.setFillColor('none');
  c.setStrokeColor('none');
  c.rect(x, y, w, h);
  c.fillAndStroke();

  const midX = x + w / 2;

  const innerX = x;
  const innerY = y;

  const innerW = w;
  const innerH = h;

  const outerX = x - 10;
  const outerY = y -  10;

  const outerW = w + (10 * 2);
  const outerH = h + (10 * 2);
  // Yellow dashed bounding box
  c.setStrokeColor('#fdf100');
  c.setDashed(true);
  c.begin();
  c.rect(outerX, outerY, outerW, outerH);
  c.stroke();
  c.setDashed(false);

  // Purple rectangle (active region)
  c.setStrokeColor('#a349a4');
  c.begin();
  c.rect(innerX, innerY, innerW, innerH);
  c.stroke();

  // Green line (diffusion)
  c.setStrokeColor('#21b04c');
  c.setStrokeWidth(3); 
  c.begin();
  c.moveTo(innerX, innerY + innerH / 2);
  c.lineTo(innerX + innerW, innerY + innerH / 2);
  c.stroke();

  // Red line (gate poly, vertical)
  c.setStrokeColor('#ed1c24');
  c.setStrokeWidth(3); 
  c.begin();
  c.moveTo(midX, innerY);
  c.lineTo(midX, innerY + innerH);
  c.stroke();

  // Connection-point dots at port positions
  const radius = 3;
  c.setFillColor(circleColor);
  c.setStrokeColor(circleColor);

  // S and D port labels painted directly on the shape (not cell values)
  // Positioned just above the child port ellipses at (35/120)*w and (85/120)*w
  // const sX = isFlipped ? x + (85 / 120) * w : x + (35 / 120) * w;
  // const dX = isFlipped ? x + (35 / 120) * w : x + (85 / 120) * w;
  const sRel = 10 / 80;
  const dRel = 70 / 80;
  const sX = isFlipped ? x + w - (sRel * w) : x + (sRel * w);  
  const dX = isFlipped ? x + w - (dRel * w) : x + (dRel * w);      
  const portY = y + 0.5 * h - 10;

  c.setFontColor(labelColor);
  c.setFontSize(9 / this.scale);
  c.text(sX+5, portY, 0, 0, "S", 'center', 'middle', 0, 'html', 0, 0, 0, 'ltr');
  c.text(dX+5, portY, 0, 0, "D", 'center', 'middle', 0, 'html', 0, 0, 0, 'ltr');  
};

export default pmosStickShape;
